import { Component , useEffect , useState } from 'react'
import Loading from '../control/Loading'
import useLoadingStore from '../stores/useLoadingStore'
import Button from '../control/Button'





// class LoadingPlayground extends Component {

//     render() {

//         return <div></div>
//         //return <Loading size={150} />
//     }
// }

const LoadingPlayground: React.FC = ()=>{
    const loadingStore = useLoadingStore();
    const [ displayText , setDisplayText ] = useState<string>('');
 

    const handleClick = ()=>{
        loadingStore.setLoading(true);
        setDisplayText('Loading Is Being Displayed For 5 Seconds')
        setTimeout(()=>{
            loadingStore.setLoading(false);
            setDisplayText('')
        },5000)
    }

    return (<div>
        <Button onClick={handleClick}>{'Click To See Loading'}</Button>
        <h1>{displayText}</h1>
    </div>)
}

export default LoadingPlayground
